import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { BarcodeReader } from "@/components/camera/components/BarCode/BarcodeReader";
import AceiteComunicacao from "@/components/AceiteComunicacao";
import BotaoPrincipal from "@/components/BotaoPrincipal";
import CamposInvalidos from "@/components/CamposInvalidos";
import InputCpfCnpj from "@/components/InputCpfCnpj";
import Logo from "@/components/Logo";
import LogoQuitaWhitelabel from "@/components/LogoQuitaWhitelabel";
import TituloTelaAcao from "@/components/TituloTelaAcao";
import { initialValuesForm } from "@/pages/common/camposUsuario";
import { ehAreaLogadaCliente, ehAreaParceiro } from "@/services/ambiente";
import { validaCpfCnpj } from "@/services/document";
import { trackKonduto } from "@/services/konduto";
import { registerMetadata } from "@/services/metadataEvent";
import {
  apenasNumeros,
  formataValorSimulador,
  formatPhoneNumber,
  validaNumeroTelefone,
  validarEmail,
} from "@/services/utils";
import { setInfoDialog } from "@/store/reducers/geral";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Alert, Divider } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import { isMobile } from "react-device-detect";
import InputMask from "react-input-mask";
import { useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import DialogTipoItemPagamento from "./EtapaItemsPagamento/DialogTipoItemPagamento";
import ItemPagamentoBoletos from "./EtapaItemsPagamento/ItemPagamentoBoletos";
import ItemPagamentoIpvas from "./EtapaItemsPagamento/ItemPagamentoIpvas";
import ItemPagamentoPix from "./EtapaItemsPagamento/ItemPagamentoPix";
import SelectComoConheceu from "./SelectComoConheceu";
import { getItemsRequestBills } from "./simulatorUtils";

export default function EtapaDadosPessoais({
  adminSimulacao,
  setAdminSimulacao,
  setNavegarEtapa,
  salvarSimulacao,
  setDadosUsuario,
  dadosUsuario,
  carregarEtapa,
  setCarregarEtapa,
}) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [infoDialogTipoItemPagamento, setInfoDialogTipoItemPagamento] =
    useState({ open: false });

  const Schema = Yup.object().shape({
    name: Yup.string().when("ehAreaLogada", {
      is: "N",
      then: () => Yup.string().nullable().required("Informe o nome"),
    }),
    whatsapp: Yup.string().when("ehAreaLogada", {
      is: "N",
      then: () =>
        Yup.string()
          .test("len", "Celular inválido", (val) => {
            return (
              apenasNumeros(val).length === 11 &&
              validaNumeroTelefone(apenasNumeros(val))
            );
          })
          .required("Informe seu celular"),
    }),
    email: Yup.string().when("ehAreaLogada", {
      is: "N",
      then: () =>
        Yup.string().email("E-mail inválido").required("Informe seu e-mail"),
    }),
    cpfCnpj: Yup.string().when("ehAreaLogada", {
      is: "N",
      then: () =>
        Yup.string()
          .required("Informe o CPF ou CNPJ")
          .test("len", "CPF ou CNPJ inválido", (val) => {
            return validaCpfCnpj(val);
          }),
    }),
  });
  const validaItemsPagamento = (values) => {
    for (let i = 0; i < values.pixs.length; i++) {
      let pix = values.pixs[i];
      if (pix.pixKey) {
        pix.pixKey = pix.pixKey.trim().toLowerCase();

        if (!pix.amount) {
          return `Informe o valor para a chave PIX "${pix.pixKey}"!`;
        }
        if (pix.pixType === "CpfCnpj") {
          const pixKey = apenasNumeros(pix.pixKey);
          if (pixKey.length !== 11 && pixKey.length !== 14) {
            return `A chave PIX "${pix.pixKey}" não é válida!`;
          }

          if (!validaCpfCnpj(pixKey)) {
            return `A chave PIX "${pix.pixKey}" não é válida!`;
          }
        }
        if (pix.pixType === "Telefone") {
          const pixKey = apenasNumeros(pix.pixKey);
          if (pixKey.length < 8 || pixKey.length > 12) {
            return `A chave PIX "${pix.pixKey}" não é válida!`;
          }

          const formataNumero = formatPhoneNumber(pix.pixKey);
          if (!validaNumeroTelefone(formataNumero)) {
            return `A chave PIX "${formataNumero}" não é válida!`;
          }
        }
        if (pix.pixType === "Email") {
          const pixKey = pix.pixKey;
          if (!validarEmail(pixKey)) {
            return `A chave PIX "${pix.pixKey}" não é válida!`;
          }
        }
      }
    }

    for (let i = 0; i < values.boletos.length; i++) {
      let boleto = values.boletos[i];
      if (boleto.barcode) {
        const barcode = apenasNumeros(boleto.barcode);
        if (
          barcode.length !== 44 &&
          barcode.length !== 47 &&
          barcode.length !== 48
        ) {
          return `O boleto com código "${boleto.barcode}" não é válido!`;
        }

        if (!boleto.amount) {
          return `Informe o valor do boleto!`;
        }
      }
    }

    for (let i = 0; i < values.ipvas.length; i++) {
      let ipva = values.ipvas[i];
      if (ipva.car_plate) {
        if (ipva.car_plate.length !== 7 && ipva.car_plate.length !== 8) {
          return `Informe a placa corretamente!`;
        }
        if (!ipva.renavam) {
          return `Informe o código Renavan"!`;
        }
        if (!ipva.amount) {
          return `Informe o valor total do IPVA/Licenciamento"!`;
        }
      }
    }
    return null;
  };

  const salvar = async (values) => {
    const itemsPagamento = getItemsRequestBills(values);

    let billValue = 0;
    itemsPagamento.forEach((itemPagamento) => {
      billValue += itemPagamento.amount;
    });
    const dados = {
      ...dadosUsuario,
      personType: values.personType,
      whatsapp: apenasNumeros(values.whatsapp),
      billValue: billValue,
      cpf: apenasNumeros(values.cpf),
      cnpj: apenasNumeros(values.cnpj),
      name: values.name,
      email: values.email,
      cupom: values.cupom || "",
      howDidYouGetUs: values.howDidYouGetUs,
      agreeToEmail: !!values.agreeToEmail,
      agreeToSms: !!values.agreeToSms,
      agreeToWhatsapp: !!values.agreeToWhatsapp,
      items: itemsPagamento,
    };

    if (!adminSimulacao) {
      const result = await salvarSimulacao(dados);
      setDadosUsuario(result);
    } else {
      setDadosUsuario({
        ...dados,
      });
    }

    setNavegarEtapa(2);
  };

  const itemPadraoPix = useMemo(() => {
    return {
      id: 1,
      pixKey: "",
      amount: "",
      pixType: "CpfCnpj",
      beneficiary: "",
      billType: "PIX",
    };
  }, []);

  const itemPadraoBoleto = useMemo(() => {
    return {
      id: 1,
      barcode: "",
      amount: "",
      billType: "BILLET",
    };
  }, []);
  const itemPadraoIPVA = useMemo(() => {
    return {
      id: 1,
      barcode: "",
      pixType: "CpfCnpj",
      amount: "",
      beneficiary: "",
      car_plate: "",
      renavam: "",
      billType: "IPVA",
    };
  }, []);

  const formik = useFormik({
    initialValues: {
      ...initialValuesForm,
      pixs: [],
      ipvas: [],
      boletos: [],
      ehAreaLogada: "N",
      agreeToEmail: user.isQuitaboletos,
      agreeToSms: user.isQuitaboletos,
      agreeToWhatsapp: user.isQuitaboletos,
    },
    validationSchema: Schema,
    onSubmit: async (values) => {
      if (!boletoOuPixForamInformados()) {
        dispatch(
          setInfoDialog({
            open: true,
            descricao: "Informe os dados de pelo menos um boleto, PIX ou IPVA!",
          })
        );
        return;
      }
      const mensagemErro = validaItemsPagamento(values);
      if (mensagemErro) {
        dispatch(setInfoDialog({ open: true, descricao: mensagemErro }));
        return;
      }
      salvar(values);
    },
  });
  const { setFieldValue } = formik;
  const adicionarBoleto = useCallback(() => {
    const boletos = formik.values.boletos;
    const itemAdd = { ...itemPadraoBoleto };
    itemAdd.id = boletos.length + 1;
    boletos.push(itemAdd);
    setFieldValue("boletos", boletos);
  }, [setFieldValue, itemPadraoBoleto, formik.values.boletos]);

  const adicionarIPVA = useCallback(() => {
    const ipvas = formik.values.ipvas;
    const itemAdd = { ...itemPadraoIPVA };
    itemAdd.id = ipvas.length + 1;
    ipvas.push(itemAdd);
    setFieldValue("ipvas", ipvas);
  }, [setFieldValue, itemPadraoIPVA, formik.values.ipvas]);

  const adicionarPix = useCallback(() => {
    const pixs = formik.values.pixs;
    const itemAdd = { ...itemPadraoPix };
    itemAdd.id = pixs.length + 1;

    pixs.push(itemAdd);
    setFieldValue("pixs", pixs);
  }, [setFieldValue, itemPadraoPix, formik.values.pixs]);

  const adicionarBoletoOuPix = useCallback(() => {
    const items = getItemsRequestBills(formik.values);
    if (items.length === 5) {
      dispatch(
        setInfoDialog({
          open: true,
          descricao:
            "Você pode adicionar no máximo 5 itens. Caso necessite, faça outra operação com os novos itens.",
        })
      );
      return;
    }
    setInfoDialogTipoItemPagamento({
      open: true,
      useNewSimulator: true,
      selecionar: (tipo) => {
        if (tipo === "boleto") {
          adicionarBoleto();
          window.location.href = "#inicio-items-pagamento";
        } else if (tipo === "IPVA") {
          adicionarIPVA();
        } else {
          adicionarPix();
        }
      },
    });
  }, [adicionarBoleto, dispatch, formik.values, adicionarIPVA, adicionarPix]);

  const itemBoletoOuPixFoiAdicionado = () => {
    const boletos = formik.values.boletos.concat(
      formik.values.pixs,
      formik.values.ipvas
    );
    return boletos.length > 0;
  };

  const boletoOuPixForamInformados = () => {
    const boletos = formik.values.boletos.concat(
      formik.values.pixs,
      formik.values.ipvas
    );
    for (let i = 0; i < boletos.length; i++) {
      let boleto = boletos[i];
      if (
        boleto.barcode ||
        boleto.pixKey ||
        (boleto.car_plate && boleto.renavam)
      ) {
        return true;
      }
    }
    return false;
  };
  const abreSimuladorPadrao = useCallback(() => {
    setDadosUsuario({
      ...dadosUsuario,
      useNewSimulator: false,
      items: [],
    });
  }, [dadosUsuario, setDadosUsuario]);

  const abreSimuladorAdmin = useCallback(() => {
    setAdminSimulacao(true);
    const usuarioAdmin = JSON.parse(
      sessionStorage.getItem("dadosUsuarioLogado")
    );
    setFieldValue("name", usuarioAdmin.name);
    setFieldValue("cpfCnpj", usuarioAdmin.cpfCnpj);
    setFieldValue("whatsapp", usuarioAdmin.whatsapp);
    setFieldValue("email", usuarioAdmin.email);
    adicionarBoletoOuPix();
  }, [setFieldValue, adicionarBoletoOuPix, setAdminSimulacao]);

  useEffect(() => {
    const registerMetadataSimulator = () => {
      if (ehAreaLogadaCliente()) {
        return;
      }
      const metaData = {};
      metaData.utmSource = searchParams.get("utm_source");
      metaData.utmMedium = searchParams.get("utm_medium");
      metaData.utmCampaign = searchParams.get("utm_campaign");
      metaData.utmId = searchParams.get("utm_id");
      metaData.utmTerm = searchParams.get("utm_term");
      metaData.idMetadataRef =
        sessionStorage.getItem("idMetadataMarketing") || "";
      metaData.isMobile = isMobile;
      metaData.userAction = "OPEN_NEW_SIMULATOR";
      metaData.url = window.location.href;

      registerMetadata(metaData);
    };

    const carregaPagamentosJaCadastrados = () => {
      const pixs = [];
      const billets = [];
      const ipvas = [];
      dadosUsuario.items.forEach((item) => {
        item.amount = formataValorSimulador(item.amount || 0);
        if (item.billType === "IPVA") {
          ipvas.push(item);
        } else if (item.billType === "PIX") {
          pixs.push(item);
        } else {
          billets.push(item);
        }
      });

      setFieldValue("pixs", pixs);
      setFieldValue("ipvas", ipvas);
      setFieldValue("boletos", billets);
    };
    const carregaDadosPreenchidos = () => {
      setFieldValue("name", dadosUsuario.name);
      setFieldValue("cpfCnpj", dadosUsuario.cpf || dadosUsuario.cnpj);
      setFieldValue("whatsapp", dadosUsuario.whatsapp);
      setFieldValue("email", dadosUsuario.email);
      setFieldValue("cupom", dadosUsuario.couponCode);
      setFieldValue("howDidYouGetUs", dadosUsuario.howDidYouGetUs);
    };

    if (!carregarEtapa) {
      return;
    }
    setCarregarEtapa(false);

    const isAdminSimulation = sessionStorage.getItem("simulation_admin");
    if (isAdminSimulation) {
      abreSimuladorAdmin();
      return;
    }

    trackKonduto("product", ehAreaParceiro());
    setFieldValue("ehAreaLogada", ehAreaLogadaCliente() ? "S" : "N");
    setFieldValue("cupom", dadosUsuario.cupom);

    if (dadosUsuario.items?.length > 0) {
      carregaPagamentosJaCadastrados();
      carregaDadosPreenchidos();
    } else {
      adicionarBoletoOuPix();
    }

    registerMetadataSimulator();
  }, [
    dadosUsuario,
    abreSimuladorAdmin,
    carregarEtapa,
    setFieldValue,
    setCarregarEtapa,
    adicionarBoletoOuPix,
    searchParams,
    dadosUsuario.boletos,
    dispatch,
    abreSimuladorPadrao,
  ]);

  return (
    <>
      <Container maxWidth="md" id="inicio-items-pagamento">
        <form onSubmit={formik.handleSubmit} noValidate>
          <>
            {" "}
            <Grid container sx={{ mb: 2 }}>
              <Grid
                item
                size={12}
                sx={{ display: "flex", justifyContent: "center" }}>
                <Logo />
                <LogoQuitaWhitelabel
                  style={{
                    margin: "auto 5px auto",
                    maxWidth: "100px",
                  }}
                />
              </Grid>
            </Grid>
            {!dadosUsuario?.infoPartner?.isRequestCompany && (
              <>
                <Grid
                  item
                  size={12}
                  sx={{
                    marginBottom: 3,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}>
                  <TituloTelaAcao>
                    Informe os dados do seu boleto ou PIX para realizar a
                    simulação.
                  </TituloTelaAcao>
                </Grid>
              </>
            )}
            {!ehAreaLogadaCliente() && (
              <Grid container spacing={1} sx={{ mb: 2 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <InputCpfCnpj {...{ formik }} />
                </Grid>

                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    id="name"
                    name="name"
                    label={
                      formik.values.personType === "PJ"
                        ? "Razão Social *"
                        : "Nome *"
                    }
                    fullWidth
                    autoComplete="given-name"
                    variant="outlined"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 6 }}>
                  <InputMask
                    mask="(99) 9 9999-9999"
                    value={formik.values.whatsapp}
                    name="whatsapp"
                    onChange={formik.handleChange}>
                    {() => (
                      <TextField
                        id="whatsapp"
                        name="whatsapp"
                        label={`Telefone/WhatsApp *`}
                        fullWidth
                        autoComplete="tel"
                        variant="outlined"
                        error={
                          formik.touched.whatsapp &&
                          Boolean(formik.errors.whatsapp)
                        }
                        helperText={
                          formik.touched.whatsapp && formik.errors.whatsapp
                        }
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    name="email"
                    label={`E-mail *`}
                    fullWidth
                    autoComplete="email"
                    variant="outlined"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Grid>

                {user.isQuitaboletos && (
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      name="cupom"
                      label="Cupom de desconto"
                      variant="outlined"
                      autoComplete="off"
                      fullWidth
                      value={formik.values.cupom}
                      slotProps={{ style: { textTransform: "uppercase" } }}
                      onChange={formik.handleChange}
                    />
                  </Grid>
                )}

                <Grid size={12}>
                  <SelectComoConheceu
                    value={formik.values.howDidYouGetUs || ""}
                    fullWidth
                    error={
                      formik.submitCount > 0 &&
                      Boolean(formik.errors.howDidYouGetUs)
                    }
                    onChange={(event) => {
                      setFieldValue("howDidYouGetUs", event.target.value);
                    }}
                  />
                </Grid>

                <Grid size={12}>
                  <Divider />
                </Grid>
              </Grid>
            )}
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ pb: "1rem" }}>
              <ItemPagamentoBoletos {...{ formik }} />
              <ItemPagamentoIpvas {...{ formik }} />
              <ItemPagamentoPix {...{ formik }} />

              <Grid size={12} align="center">
                <BotaoPrincipal
                  startIcon={<AddIcon />}
                  onClick={() => {
                    adicionarBoletoOuPix();
                  }}>
                  {itemBoletoOuPixFoiAdicionado()
                    ? "ADICIONAR OUTRO BOLETO, PIX OU IPVA"
                    : "ADICIONAR BOLETO, PIX OU IPVA"}
                </BotaoPrincipal>
              </Grid>

              <CamposInvalidos {...{ formik }} />

              <Grid container spacing={3} sx={{ mt: 1, ml: 1 }}>
                <Grid size={12}>
                  {user.isQuitaboletos && !ehAreaLogadaCliente() && (
                    <AceiteComunicacao {...{ formik }} />
                  )}
                </Grid>
                <Grid size={12}>
                  <Alert severity="warning">
                    <Typography>
                      Nosso prazo médio é de apenas <b>algumas horas</b>, porém
                      pode levar até <b>2 dias úteis</b> para o débito ser
                      quitado!
                    </Typography>
                  </Alert>
                </Grid>

                <Grid size={12}>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <BotaoPrincipal
                      endIcon={<ArrowForwardIcon />}
                      id="btn-avancar-simulacao"
                      type="submit">
                      AVANÇAR
                    </BotaoPrincipal>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </>
        </form>
      </Container>

      {infoDialogTipoItemPagamento?.open && (
        <DialogTipoItemPagamento
          {...{ infoDialogTipoItemPagamento, setInfoDialogTipoItemPagamento }}
        />
      )}
    </>
  );
}
